module.exports = __webpack_public_path__ + "static/media/1.0dd01f6e.png";